import { AppContext } from './AppContext';
import { Car, } from "../models/booking";
import { GET_CARS,  } from './queries';
import client from "./apolloClient";



let _cars: Car[] | null;

export const getCars = async (refresh: boolean): Promise<Car[] | null> => {
    if (_cars?.length == undefined || refresh === true) {
        _cars = await fetchData();
    }
    return _cars;
}

export const fetchData = async (): Promise<Car[] | null> => {

    try {
        const { data } = await client.query({
            query: GET_CARS,
            context: {
                headers: {
                    Authorization: AppContext.loggedAuthToken  ? `Bearer ${ AppContext.loggedAuthToken }` : '',
                },
            }
        });
        let cars = data?.getCars?.sort((a: any, b: any) => { return a.carNumber.localeCompare(b.carNumber) });
        const emptyCar: Car = { _id: "000000000000000000000000", carModel: '', carNumber: '', carType: '', status: "" };
        return [...cars];
        // return data?.getCars
    } catch (error) {
        console.log('Error fetching cars:', error);
        return null;
    }
};


export const getCar = (id: string): Car => {
    getCars(true);

    let car = _cars?.find(car => car._id === id);
    if (car === undefined) {
        return { _id: "", carModel: '', carNumber: 'TBD....', carType: '', status: "" };
    }

    return car;
}


